import { render, staticRenderFns } from "./GjwBimfaceViewer.vue?vue&type=template&id=63bfcff7&scoped=true&"
import script from "./GjwBimfaceViewer.vue?vue&type=script&lang=js&"
export * from "./GjwBimfaceViewer.vue?vue&type=script&lang=js&"
import style0 from "./GjwBimfaceViewer.vue?vue&type=style&index=0&id=63bfcff7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfcff7",
  null
  
)

export default component.exports